import OrderService from '@/services/OrderService'
import { defineStore } from 'pinia'

function unwrapItems(response) {
  if (Array.isArray(response))
    return { items: response, total: response.length }

  const data = response?.data || response || {}
  const items = data.items || data.orders || data.results || []
  const total = data.totalItems || data.total || data.count || items.length

  return { items, total }
}

function unwrapItem(response) {
  return response?.data?.item || response?.data?.order || response?.item || response?.order || response?.data || response || {}
}

export const useOrderStore = defineStore('OrderStore', {
  state: () => ({
    orders: [],
    order: {},
    totalOrders: 0,
    loading: false,
  }),
  getters: {
    getOrders() {
      return this.orders
    },
    getOrder() {
      return this.order
    },
  },
  actions: {
    async fetchOrders(params = {}) {
      this.loading = true
      try {
        const response = await OrderService.getOrders(params)
        const { items, total } = unwrapItems(response)

        this.orders = items
        this.totalOrders = total

        return { items, total, response }
      } catch (error) {
        console.error('Error fetching orders:', error)
        throw error
      } finally {
        this.loading = false
      }
    },

    async fetchOrder(id) {
      this.loading = true
      try {
        const response = await OrderService.getOrder(id)
        this.order = unwrapItem(response)

        return this.order
      } catch (error) {
        console.error('Error fetching order:', error)
        throw error
      } finally {
        this.loading = false
      }
    },

    async createOrder(order) {
      const response = await OrderService.createOrder(order)
      this.order = unwrapItem(response)

      return response
    },

    async updateOrder(id, order) {
      const response = await OrderService.updateOrder(id, order)
      this.order = unwrapItem(response)

      return response
    },

    async deleteOrder(id) {
      return await OrderService.deleteOrder(id)
    },

    async addActivity(id, { title, description }) {
      const response = await OrderService.addActivity(id, { title, description })
      const updated = unwrapItem(response)
      if (updated?._id || updated?.activity) {
        this.order = updated
      }
      return response
    },

    setActiveOrder(order) {
      this.order = order
    },
  },
})